import swaggerClient from "../remote-client";

export default class BookingsServiceImpl {
  /**
   * Get all the provinces by Fondo Est
   */
  getAllProvinces() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getProvincesCovered(
          {},
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => {
            let provinces = res.body.coveredList.map(province => {
              let p = province;
              p.province["covered"] = p.covered;
              delete p.covered;
              p.province["bookable"] = p.bookable;
              delete p.bookable;
              p.province["fullyCovered"] = p.fullyCovered;
              delete p.fullyCovered;
              return p.province;
            });
            resolve(provinces);
          })
          .then(error => reject(error));
      });
    });
  }

  /**
   * Retrieve all the offices for the given province
   */
  getOfficesByProvince(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getOfficesByProvinceWithProvinceCode(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(result => {
            resolve(result.body?.hfOffices || []);
          })
          .then(error => reject(error));
      });
    });
  }

  /**
   * get list of health plan services (name and aliases for autocomplete) (TBD in the member healthPlans)
   * @param payload {search,provinceCode}
   */
  getServiceNames(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getServiceNames(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.serviceNameList))
          .then(error => reject(error));
      });
    });
  }

  /**
   * get list of Health facilities Offices  with constraints
   */
  getOffices(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postOfficesBooking(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body.hfOffices))
          .then(error => reject(error));
      });
    });
  }

  /**
   * get list of Health facilities Office name by Key with constrains (autocomplete)
   * @param province
   * @param serviceId
   * @param obese
   * @param claustrophobia
   * @param toSearch
   * @param memberGeoLocation
   */
  getOfficesNameByKey(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postOfficesNameByKey(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body.hfOffices))
          .then(error => reject(error));
      });
    });
  }

  getOfficesByRanking(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postOfficesByHfrs(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => {
            let result = [];
            let byPhone = res.body?.hfOfficesByPhoneBased
              ? res.body.hfOfficesByPhoneBased
              : [];
            result.push(byPhone);
            let bySlot = res.body?.hfOfficesSlotBased
              ? res.body.hfOfficesSlotBased
              : [];
            result.push(bySlot);
            let byTimePeriod = res.body?.hfOfficesTimePeriodBased
              ? res.body.hfOfficesTimePeriodBased
              : [];
            result.push(byTimePeriod);
            resolve(result.flat());
          })
          .then(error => reject(error));
      });
    });
  }

  getOfficesByDate(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postOfficesByDate(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body))
          .then(error => reject(error));
      });
    });
  }

  getOfficesByDateByDistance(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postOfficesByDateByDistance(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body))
          .then(error => reject(error));
      });
    });
  }

  /**
   * get list of doctors (autocomplete)
   * province
   * serviceId
   * obese
   * claustrophobia
   * toSearch
   */
  getDoctors(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getDoctors(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.doctorList))
          .then(error => reject(error));
      });
    });
  }

  callGetDoctorsByOfficeService(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getDoctorsWithOfficeServiceId(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.doctors))
          .then(error => reject(error));
      });
    });
  }

  /**
   * Returns the office info based on doctorId and officeserviceId
   * @param {*} payload
   */
  getOfficeService(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getOfficeserviceWithOfficeserviceId(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.hfOffice))
          .then(error => reject(error));
      });
    });
  }

  /**
   * get member residual ceiling for specified health plan service
   * @param {*} id
   */
  getCeilingServiceWithId({ id, year }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getCeilingServiceWithIdWithYear(
          {
            id,
            year
          },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.residualCeiling))
          .then(error => reject(error));
      });
    });
  }

  /**
   * get info for specified health plan service
   * @param {*} payload
   */
  getServiceWithId(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postService(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body.service))
          .then(error => reject(error));
      });
    });
  }

  getExemption(serviceId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getExemptionServiceWithId(
          { id: serviceId },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.exemption))
          .then(error => reject(error));
      });
    });
  }

  getSlots(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getSlotOfficeserviceWithOfficeserviceId(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .then(error => reject(error));
      });
    });
  }

  getSlotsForMonths(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getSlotOfficeserviceWithOfficeserviceIdMonth(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .then(error => reject(error));
      });
    });
  }

  getOperationalService(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getOperational_serviceWithServiceIdOfficeWithOfficeId(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.service))
          .then(error => reject(error));
      });
    });
  }

  createReminder(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postMemorandum(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  sendFeedBack(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithAppointmentIdFeedbackWithFeedback(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }

  askForCoverage(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.postAskForCoverageWithYearWithMonth(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Retrieve all the descriptions for the covered and bookable provinces
   */
  callGetCoveredAndBookableProvincesDescriptions() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getCoveredAndBookableProvincesDescriptions(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          resolve(result.body);
        })
        .catch(error => reject(error));
    });
  }
}
